<main class="container my-5 pt-4">
    <div class="container my-5">
        <div class="custom-card p-4">
          <dl>
            <h3 class="text-center">Frequently Asked Questions</h3>
            <dt>How do I create an account?</dt>
            <dd>
              <a href="/landing" target="_self">
                Accounts must be created with a GCPSK12.org email.<br>
                Please visit the following link to create your account.
              </a>
            </dd>
            <br>
            <dt>How do I reset my password?</dt>
            <dd>
              <a href="/landing">
                Click on "Forgot Password" at the bottom of the login section and enter your email account.<br>
                An email will be sent to you with the reset password link.
              </a>
            </dd>
            <br>
            <dt>How do I search for partners?</dt>
            <dd>
              <a href="/find-partners">
                Hover over the "PARTNERS" option at the top,<br>
                and a dropdown menu labeled "FIND A PARTNER" will appear.
              </a>
            </dd>
            <br>
            <dt>How do I become a partner?</dt>
            <dd>
              <a href="partner-submission">
                Fill out the submission form to become a partner.<br>
                You will receive a notification upon acceptance.
              </a>
            </dd>
            <br>
            <dt>How do I get the website for the partner I want?</dt>
            <dd>
              <a href="/find-partners">
                Once you find the partner you're interested in, click on their card.<br>
                A partner profile page will appear, and the website link will be in the description.
              </a>
            </dd>
            <br>
            <dt>Other Questions? Contact Us!</dt>
          </dl>
        </div>
      </div>
    </main>